import { render, staticRenderFns } from "./ShippingCostInquiry.vue?vue&type=template&id=ea2cf8d0"
import script from "./ShippingCostInquiry.vue?vue&type=script&lang=js"
export * from "./ShippingCostInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea2cf8d0')) {
      api.createRecord('ea2cf8d0', component.options)
    } else {
      api.reload('ea2cf8d0', component.options)
    }
    module.hot.accept("./ShippingCostInquiry.vue?vue&type=template&id=ea2cf8d0", function () {
      api.rerender('ea2cf8d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/schedule/ShippingCostInquiry.vue"
export default component.exports